import { H2 } from "@/shared/components/typography";
import { useNavigate, useParams } from "react-router";
import t from "@/lang/lang";
import { VbsMilestones } from "@/routes/processes/[processId]/vbs/overview/_components/vbs-milestones";
import { ProcessInformationCard } from "@/routes/processes/[processId]/_components/process-information-card";
import { CpyDialog } from "@/services/backend/cpy/components/cpy-dialog";
import { CpyName } from "@/services/backend/cpy/types/entity-names";
import { Button } from "@/shared/components/ui/button";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { Copy } from "lucide-react";
import { SoureSearchField } from "@/services/backend/cpy/components/cpy-sources-table";
import { FilterMode } from "@/shared/lib/filter/filter";
import { DeleteProcessDialog } from "@/services/backend/processes/components/delete-process-dialog";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { VbsBreadcrumbs } from "@/routes/processes/[processId]/vbs/_components/vbs-breadcrumbs";

export default function OverviewRoute() {
  const { processId } = useParams();
  const { data: process } = useProcessesProcessShowQuery({ id: processId! });
  const milestonesActive = useBooleanFlagValue(
    "gsm.processes.process.milestones",
    false,
  );
  const navigate = useNavigate();

  if (!process) {
    return null;
  }

  const breadcrumbs = (
    <VbsBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Übersicht")}</BreadcrumbPage>
      </BreadcrumbItem>
    </VbsBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <div className="flex">
        <H2 className="border-none">{t("Übersicht")}</H2>
        <div className="ml-auto flex gap-2">
          <DeleteProcessDialog
            processId={process.id}
            onSuccess={() => navigate("/processes")}
          />
          <CpyDialog
            destinationEntityName={CpyName.ProcessesProcess}
            destinationId={process.id}
            searchField={SoureSearchField.Name}
            initialParams={{
              serviceKind: {
                active: true,
                values: [process.serviceKind],
              },
              company: {
                active: true,
                values: [process.companyId],
              },
              serviceObject: {
                active: true,
                mode: FilterMode.NotNull,
              },
              customer: {
                active: !process.customerId && process.customerId !== null,
                values: [process.customerId!],
              },
              branch: {
                active: process.branches.length > 0,
                values: process.branches,
              },
              name: {
                active: true,
                mode: FilterMode.Like,
                values: [],
              },
            }}
            description={t(
              "Sie können nach dem Thema der Verkaufschance suchen. Wenn im Vorgang bereits werde gesetzt sind, werden die Ergebnisse nach diesen gefiltert.",
            )}
            trigger={
              <Button variant="outline" className="ml-auto">
                <Copy />
                {t("Aus Dynamics CRM kopieren")}
              </Button>
            }
            disabled={!process.customerId}
            hideOrderBy
          />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2">
        <ProcessInformationCard process={process} />
        {milestonesActive && <VbsMilestones processId={processId!} />}
      </div>
    </ProcessPageMainTemplate>
  );
}
